import { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaCog } from 'react-icons/fa';
import { PlatformConfigurableListItem } from 'src/motornet/types';

type Props = {
	isOpen: boolean;
	item: PlatformConfigurableListItem | null;
	saving?: boolean;
	onClose: () => void;
	onConfirm: (configurable: boolean) => void;
};

export function UpdateConfigurableModal({
	isOpen,
	item,
	saving = false,
	onClose,
	onConfirm,
}: Props) {
	const { t } = useTranslation();
	const [configurable, setConfigurable] = useState(false);

	useEffect(() => {
		if (item) {
			setConfigurable(!item.excluded);
		}
	}, [item]);

	if (!item) return null;

	return (
		<Modal show={isOpen} onHide={onClose}>
			<Modal.Header closeButton>
				<Modal.Title className="fs-5">
					{item.make} {item.model}
					<div className="text-muted fw-normal fs-6">{item.trim}</div>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Form>
					<div className="d-flex align-items-start justify-content-between mb-1">
						<div>
							<div className="fw-semibold d-flex align-items-center gap-2">
								<FaCog />
								{t('configurable')}
							</div>
						</div>
					</div>

					<div className="border rounded p-3 mt-3">
						<Form.Label className="fw-semibold mb-2">
							{t('configurable')}
						</Form.Label>
						<div className="d-flex gap-4">
							<Form.Check
								type="radio"
								id="configurable_yes"
								name="configurable"
								label={t('yes')}
								checked={configurable === true}
								onChange={() => setConfigurable(true)}
							/>
							<Form.Check
								type="radio"
								id="configurable_no"
								name="configurable"
								label={t('no')}
								checked={configurable === false}
								onChange={() => setConfigurable(false)}
							/>
						</div>
					</div>
				</Form>
			</Modal.Body>

			<Modal.Footer>
				<Button variant="link" onClick={onClose} disabled={saving}>
					{t('cancel')}
				</Button>
				<Button onClick={() => onConfirm(configurable)} disabled={saving}>
					{t('confirm')}
				</Button>
			</Modal.Footer>
		</Modal>
	);
}
